import React from "react";
import { Text } from "../../formitems/Index";
import { LeftOutlined } from "@ant-design/icons";
import Iframe from "react-iframe";

const ViewQualificationss = ({ close, data }) => {
  const q_data = data?.aatmsv4_qualificationrecords[0];
  return (
    <div className="qualificationPage">
      <div>
        <div className="addQualification__form qualificationPage__left">
          <div className="addQualification__form--title">
            <span className="client-back" onClick={() => close()}>
              {<LeftOutlined />} Qualifications
            </span>
            View Qualification Records
          </div>
          <h4>
            <b>Qualification Details:</b>
          </h4>
          <Text title="Name" value={q_data?.crew?.name} disabled />
          <Text title="Q-Code" value={q_data?.qcode} disabled />
          <Text title="Qualification" value={q_data?.qualification} disabled />
          <Text
            title="Document Number"
            value={q_data?.documentnumber}
            disabled
          />
          <Text
            title="Issuing-Authority"
            value={q_data?.issuingauthority}
            disabled
          />
          <Text title={q_data?.caption1} value={q_data?.data1} disabled />
          <Text title={q_data?.caption2} value={q_data?.data2} disabled />
          <Text title={q_data?.caption3} value={q_data?.data3} disabled />
          <h4>
            <b>Issue date & validity:</b>
          </h4>
          <Text title="Issue-Date" value={q_data?.issuedate} disabled />
          <Text title="Valid-Date" value={q_data?.validdate} disabled />
          <h4>
            <b>Document Status:</b>
          </h4>
          <Text
            title="Validated"
            value={q_data?.validated === true ? "Yes" : "No"}
            disabled
          />
          <Text
            title="Active"
            value={q_data?.active === true ? "Yes" : "No"}
            disabled
          />
          <button className="submit-button">Save / Print</button>
          <button className="cancel-button" onClick={() => close()}>
            Exit
          </button>
        </div>
      </div>
      <div className="qualificationPage__right">
        {q_data?.document ? (
          <Iframe
            url={q_data.document}
            id="pdfId"
            className="pdfClassname"
            display="initial"
            position="relative"
          />
        ) : null}
      </div>
      {/* <div style={{ width: "50%" }}>
        <img
          style={{
            width: "100%",
            height: "97%",
            marginTop: "68px",
            borderRadius: "25px",
          }}
          src={q_data?.document}
          alt=""
        />
      </div> */}
    </div>
  );
};

export default ViewQualificationss;
